<template>
    <div v-if="!isNew">
        <v-row dense>
            <v-col
                    cols="12"
            >
                <v-card-actions>
                    <h5>Исполнители</h5>
                    <v-spacer></v-spacer>
                    <v-dialog
                            v-if="canAddExecutor"
                            v-model="dialog"
                            max-width="500px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                    color="primary"
                                    dark
                                    outlined
                                    x-small
                                    v-bind="attrs"
                                    v-on="on"
                            >
                                {{$vuetify.lang.t('$vuetify.page.action.btnAdd')}}
                            </v-btn>
                        </template>
                        <v-card>
                            <v-card-actions>
                                <v-text-field
                                        v-model="searchValue"
                                        denses
                                        placeholder="Поиск"
                                >
                                    <v-icon
                                            slot="append"
                                    >
                                        mdi-magnify-scan
                                    </v-icon>
                                </v-text-field>
                            </v-card-actions>
                            <v-card-text>
                                <v-list
                                        class="overflow-y-auto"
                                        max-height="calc(95vh - 230px)"
                                >
                                    <v-list-item
                                        v-for="item in executorSearchList"
                                        :key="item.id"
                                    >
                                        <v-list-item-action>
                                            <v-checkbox v-model="executorToAdd" :value="item.id"></v-checkbox>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title v-html="item.name"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-card-text>


<!--                            <v-card-text>-->
<!--                                <v-list style="height: 300px;">-->
<!--                                    <v-list-item-->
<!--                                            v-for="item in executorDictList"-->
<!--                                            :key="item.id"-->
<!--                                    >-->
<!--                                        <v-list-item-action>-->
<!--                                            <v-checkbox v-model="executorToAdd" :value="item.id"></v-checkbox>-->
<!--                                        </v-list-item-action>-->
<!--                                        <v-list-item-content>{{item.name}}</v-list-item-content>-->
<!--                                    </v-list-item>-->
<!--                                </v-list>-->
<!--                            </v-card-text>-->

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                        color="blue darken-1"
                                        text
                                        @click="closeDialog"
                                >
                                    {{$vuetify.lang.t('$vuetify.page.action.btnCancel')}}
                                </v-btn>
                                <v-btn
                                        color="blue darken-1"
                                        text
                                        @click="addExecutors"
                                        :loading="axiosLoading"
                                >
                                    {{$vuetify.lang.t('$vuetify.page.action.btnSave')}}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-card-actions>
            </v-col>
        </v-row>
        <v-row v-if="currentService" dense>
            <v-col
                    cols="12"
            >
                <v-chip
                        v-for="executor in currentService.executors"
                        :key="executor.id"
                        :close="canAdd"
                        close-icon="mdi-close-outline"
                        color="blue"
                        label
                        outlined
                        small
                        class="mr-3 mb-3"
                        v-on:click:close="deleteExecutor(executor.id)"
                >
                    {{executor.name}}
                </v-chip>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: "ServiceExecutorPanel",
        props: {
            serviceId: String,
            canAdd: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                dialog: false,
                executorToAdd: [],
                searchValue: null
            }
        },
        created() {
            this.$store.dispatch('retrieveExecutorDictionaryList')
        },
        computed: {
            currentService() {
                return this.$store.getters.currentService ?? this.$store.getters.currentExecutorService
            },
            executorDictList() {
                if (this.currentService && this.currentService.executors) {
                    let serviceExecutorList = this.currentService.executors
                    return this.$store.getters.executorDictionaryList.filter(item => {
                        return !serviceExecutorList.some(serviceExecutor => serviceExecutor.id === item.id)
                    })
                } else {
                    return this.$store.getters.executorDictionaryList
                }
            },
            executorSearchList(){
                let sv = ''
                if (this.searchValue) {
                    sv = this.searchValue.toLowerCase()
                }
                return this.searchValue ?
                    this.executorDictList.filter(item => item.name.toLowerCase().includes(sv)) :
                    this.executorDictList
            },
            isNew() {
                return this.serviceId === '00000000-0000-0000-0000-000000000000'
            },
            canAddExecutor(){
                return this.executorDictList.length > 0 && this.canAdd
            }
        },
        methods: {
            addExecutors() {
                this.$store.dispatch('addServiceExecutors', {
                    serviceId: this.serviceId,
                    executorList: this.executorToAdd
                }).then(() => this.closeDialog())
            },
            deleteExecutor(executorId) {
                this.$store.dispatch('deleteServiceExecutor', {
                    serviceId: this.serviceId,
                    executorId: executorId
                }).then(() => this.closeDialog())
            },
            closeDialog() {
                this.dialog = false
                this.executorToAdd = []
            }
        }
    }
</script>

<style scoped>

</style>